import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import UpgradeYourPlan from "./child/UpgradeYourPlan";
import NumbersOfCalls from "./child/NumbersOfCalls";
import TotalCallsMinutes from "./child/TotalCallsMinutes";
import ReasonCallEnded from "./child/ReasonCallEnded";
import { useDate } from "../contexts/DateContext";
import { fetchOrgAnalytics } from "../store/analyticsSlice";
import { motion } from "framer-motion";

const DashBoardLayerNine = () => {
  const dispatch = useDispatch();
  const { startDate, endDate } = useDate();

  const { data, loading, error } = useSelector((state) => state.analytics);

  useEffect(() => {
    dispatch(fetchOrgAnalytics({ startDate, endDate }));
  }, [dispatch, startDate, endDate]); 

  if (loading) {
    return (
      <div className="bg-white mx-12" style={{ height: "83vh", borderRadius: '10px', width: 'calc(100% - 24px)' }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
            width: "100%",
          }}
        >
          <img
            src="assets/gif/loader1.gif"
            alt="Loading..."
            style={{ width: "200px", height: "200px" }}
          />
        </div>
      </div>
    );
  }

  return (
    <motion.div 
    initial={{
      opacity: 0
    }}
    animate={{
      opacity: 1
    }}
    transition={{
      duration: 1
    }}
    className="row gy-4">
      <UpgradeYourPlan date={{ startDate, endDate }} />
      <NumbersOfCalls />
      <TotalCallsMinutes />
      
      <ReasonCallEnded />
    </motion.div>
  );
};

export default DashBoardLayerNine;